import { get } from 'lodash';
import { NETWORK_ERROR } from '../constants';

const isNetworkError = error => error.networkError !== undefined;

const networkErrorParser = error => (
  {
    hasErrors: () => isNetworkError(error),
    parse: () => (
      {
        type: NETWORK_ERROR,
        fields: null,
        message: get(error, 'networkError.message'),
      }
    )
  }
);

export default networkErrorParser;
